const config = {
  site: {
    title: "Aggregation Platform Documentation",
    /*
    banner: {
      message: "Welcome to our beta documentation!",
      color: "info", // "note" | "tip" | "info" | "caution" | "danger" or custom
      dismissible: true,
    },
    */
    logo: {
      src: {
        light: "images/Fennica_white.png",
        dark: "images/Fennica_logo.png",
      },
      alt: "Fennica Gaming",
      href: "/",
    },
    footer: {
      position: "center",
      copyright: `© ${new Date().getFullYear()} Aggregation Platform. All rights reserved.`,
    },
  },

  theme: {
    // registryUrl: "https://tweakcn.com/r/themes/clean-slate.json",
    registryUrl: "https://tweakcn.com/r/themes/solar-dusk.json",
  },

  defaults: {
    apis: {
      examplesLanguage: "java",
      schemaDownload: {
        enabled: true,
      },
    },
  },

  apis: {
    type: "file",
    input: [
      "./specs/aggregation-openapi-20260526.json",
      "./specs/aggregation-openapi-preview.json"
    ],
    path: "/api",
    options: {
      examplesLanguage: "java", // Default language for code examples
      disablePlayground: false, // Disable the interactive API playground
      disableSecurity: false, // Disable the security support
      disableSidecar: false, // Disable the sidecar completely
      showVersionSelect: "always", // Control version selector visibility
      expandAllTags: true, // Control initial expanded state of tag categories
    },
  },

  docs: {
    files: "/pages/**/*.{md,mdx}",
    defaultOptions: {
      toc: true,
      disablePager: false,
      showLastModified: true,
      copyPage: true,
    },
    publishMarkdown: true,
    llms: {
      llmsTxt: true, // Generate llms.txt summary file
      llmsTxtFull: true, // Generate llms-full.txt with complete content
      includeProtected: false,
    },
  },

  navigation: [
    {
      type: "category",
      label: "Documentation",
      icon: "book",
      items: [
        {
          type: "doc",
          label: "Introduction",
          file: "welcome",
          icon: "soup",
        },
        {
          type: "doc",
          label: "Overview",
          file: "overview",
          icon: "telescope",
        },
        {
          type: "category",
          label: "Domain Reference",
          icon: "blocks",
          items: [
            {
              type: "doc",
              label: "Introduction",
              file: "domain_reference/introduction",
            },
            {
              type: "doc",
              label: "Games",
              file: "domain_reference/games",
            },
            {
              type: "doc",
              label: "Sessions",
              file: "domain_reference/sessions",
            },
            {
              type: "doc",
              label: "Rounds",
              file: "domain_reference/rounds",
            },
            {
              type: "doc",
              label: "Transactions",
              file: "domain_reference/transactions",
            },
            {
              type: "doc",
              label: "Wallets",
              file: "domain_reference/wallets",
            },
          ],
        },
        {
          type: "category",
          label: "API Guidelines",
          icon: "cog",
          items: [
            {
              type: "category",
              label: "Design Philosophy",
              icon: "brain",
              items: [
                {
                  type: "doc",
                  label: "Symmetrical Design (Operator vs. Provider)",
                  file: "api_guidelines/design_philosophy/symmetrical",
                },
                {
                  type: "doc",
                  label: "Resource-Oriented Approach",
                  file: "api_guidelines/design_philosophy/entities",
                },
                {
                  type: "doc",
                  label: "Statelessness",
                  file: "api_guidelines/design_philosophy/statelessness",
                },
              ],
            },
            {
              type: "category",
              label: "URI Structure & Naming",
              icon: "folder-tree",
              items: [
                {
                  type: "doc",
                  label: "Endpoint Naming",
                  file: "api_guidelines/uri_structure/endpoints",
                },
                {
                  type: "doc",
                  label: "Versioning",
                  file: "api_guidelines/uri_structure/versioning",
                },
              ],
            },
            {
              type: "category",
              label: "Data Format Conventions",
              icon: "book-marked",
              items: [
                {
                  type: "doc",
                  label: "JSON as the Standard",
                  file: "api_guidelines/data_formats/json",
                },
                {
                  type: "doc",
                  label: "Common Data Types",
                  file: "api_guidelines/data_formats/common_datas",
                },
                {
                  type: "doc",
                  label: "Standard Response Composition",
                  file: "api_guidelines/data_formats/response_composition",
                },
              ],
            },
            {
              type: "category",
              label: "Error Handling",
              icon: "bomb",
              items: [
                {
                  type: "doc",
                  label: "Use of HTTP Status Codes",
                  file: "api_guidelines/error_handling/http_status_codes",
                },
                {
                  type: "doc",
                  label: "Standard Error Response Body",
                  file: "api_guidelines/error_handling/standard_error_body",
                },
              ],
            },
          ],
        },
        {
          type: "link",
          label: "Fennica Gaming",
          to: "https://www.fennicagaming.com",
          icon: "dices",
        },
      ],
    },
    {
      type: "link",
      to: "api",
      label: "API Reference",
    },
    {
      type: "category",
      label: "Guides",
      icon: "rocket",
      items: [
        {
          type: "doc",
          label: "How to Integrate",
          file: "guides/howto",
          icon: "wrench",
        },
        {
          type: "doc",
          label: "Game Operator Integration Guide",
          file: "guides/operator",
          icon: "gamepad",
        },
        {
          type: "category",
          label: "Operator Advanced Topics",
          icon: "pencil-ruler",
          items: [
            {
              type: "doc",
              label: "Bundled Transactions and Transaction Context",
              file: "guides/advanced/operator_bundled_transactions",
            },
          ],
        },
        {
          type: "doc",
          label: "Game Provider Integration Guide",
          file: "guides/provider",
          icon: "swords",
        },
        {
          type: "category",
          label: "Provider Advanced Topics",
          icon: "pencil-ruler",
          items: [
            {
              type: "doc",
              label: "Game Launch URL Tokens",
              file: "guides/advanced/launch_tokens",
            },
            {
              type: "doc",
              label: "Multiple Payment Methods",
              file: "guides/advanced/payment_methods",
            },
            {
              type: "doc",
              label: "Bundled Transactions and Transaction Context",
              file: "guides/advanced/provider_bundled_transactions",
            },
          ],
        },
        /*
        {
          type: "doc",
          label: "AP Frame",
          file: "guides/ap_frame",
          icon: "dices",
        },
        {
          type: "doc",
          label: "Adapter Worker",
          file: "guides/adapter",
          icon: "dices",
        },
        */
      ],
    },
  ],

  search: {
    type: "pagefind",
    // Optional: Maximum number of sub results per page
    maxSubResults: 3,
    // Optional: Configure search result ranking (defaults shown below)
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },

  redirects: [{ from: "/", to: "/welcome" }],
};

export default config;
